export enum RuleBundleTypesEnum {
  SINGLE = 'single',
  SLA = 'sla',
  CSAT = 'csat',
  CUSTOM_VIEW = 'custom_view',
  REQUIRED_TAGGING = 'required_tagging',
}
